import script from "./RSInject.vue?vue&type=script&setup=true&lang=ts"
export * from "./RSInject.vue?vue&type=script&setup=true&lang=ts"

import "./RSInject.vue?vue&type=style&index=0&id=26564b47&lang=less"
import "./RSInject.vue?vue&type=style&index=1&id=26564b47&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26564b47"]])

export default __exports__